// ─────────────────────────────────────────────────────────────────
// Konfiguration för bakgrundsborttagning i webbläsaren. Den gällande
// konfigurationen (inkl. feature flag) kommer från API:t, GET /api/features
// (apps/api/src/images/backgroundRemovalConfig.ts), så modell, färg m.m.
// kan bytas med env på Cloud Run utan ny build. Värdena här är reserv om
// API:t inte svarar — då är funktionen avstängd.
// ─────────────────────────────────────────────────────────────────

export interface BgRemovalConfig {
  enabled: boolean;
  /** Modell-id under modellvärden. Licensen måste vara MIT/Apache 2.0/BSD. */
  modelId: string;
  dtype: 'fp16' | 'fp32';
  /** Max längsta sida (px) på bilden som skickas till modellen. */
  inputSize: number;
  /** Bakgrundsfärg i den frilagda bilden (#rrggbb) — inte transparent. */
  background: string;
  /** 'self' = vår egen /models/ på Firebase Hosting, annars en bas-URL ('' = Hugging Face). */
  modelHost: string;
  /** Max tid för själva inferensen (efter att modellen laddats). */
  timeoutMs: number;
}

export const DEFAULT_BG_REMOVAL_CONFIG: BgRemovalConfig = {
  enabled: false,
  modelId: 'qvestium/isnet-general-use',
  dtype: 'fp16',
  inputSize: 1024,
  background: '#F4F4F4',
  modelHost: 'self',
  timeoutMs: 30_000,
};

/** Största sida på den frilagda bilden. iOS Safari klarar max ~16,7 MP per canvas. */
export const MAX_OUTPUT_SIDE = 4000;

export interface ModelLocation {
  /** Bas-URL som modellfilerna hämtas från, eller null för Hugging Face. */
  remoteHost: string | null;
  /** Var ONNX Runtimes wasm-filer hämtas från, eller null för standard (jsDelivr). */
  wasmBase: string | null;
}

// "self" pekar på webbens egen /models/, dit scripts/fetch-bg-model.mjs
// laddar ner modellen (och ONNX Runtimes wasm) inför deploy till Firebase.
export function resolveModelLocation(modelHost: string, origin: string): ModelLocation {
  const host = modelHost.trim();
  if (!host) return { remoteHost: null, wasmBase: null };
  const base = (host === 'self' ? `${origin}/models/` : host).replace(/\/?$/, '/');
  return { remoteHost: base, wasmBase: `${base}ort/` };
}
